/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HolderDTO = {
    type: HolderDTO.type;
}

export namespace HolderDTO {

    export enum type {
        VALUE_HOLDER = 'VALUE_HOLDER',
        INTERNAL_IDENTIFIER_HOLDER = 'INTERNAL_IDENTIFIER_HOLDER',
    }


}
